export default{
  install(Vue, options) {
    // Add a 'bus' props?
    // Bind events to bus
    Vue.mixin({
      mounted() {
        var events = this.$options.events;
        this.listeners = {};
        for (var name in events) {
          let bound = catchErrors(events[name].bind(this));
          this.listeners[name] = bound;
          if (this.bus) this.bus.$on(name, bound);
        }
      },
      beforeDestroy() {
        for (var name in this.listeners) {
          if (this.bus) this.bus.$off(name, this.listeners[name]);
        }
        this.listeners = {};
      },
      watch: {
        bus(newBus, oldBus) {
          for (var name in this.listeners) {
            let bound = this.listeners[name];
            if (oldBus) oldBus.$off(name, bound);
            if (newBus) newBus.$on(name, bound);
          }
        }
      }
    });
  }
};

function catchErrors(func) {
  return (...args) => {
    try {
      return func(...args);
    } catch(e) {
      console.error('Error in VueBus event handler', e);
    }
  };
}



// WEBPACK FOOTER //
// ./src/lib/VueBus.js